<script setup>
import { Toggle } from "@components";
import { computed } from "vue";
import {
  addonStaff,
  addonCalendar,
  addonHoliday,
  addonPayment,
  addonChatWidget,
} from "./addonSvg.js";

const emit = defineEmits(["change"]);

const props = defineProps({
  addon: {
    type: Object,
    default: () => ({}),
  },
});

const toggleClicked = () => {
  const newAddon = { ...props.addon, status: !props.addon.status };
  emit("change", newAddon);
};

const icon = computed(() => {
  if (!props.addon.svg) return null;
  switch (props.addon.svg) {
    case "addonCalendar":
      return addonCalendar;
    case "addonHoliday":
      return addonHoliday;
    case "addonPayment":
      return addonPayment;
    case "addonStaff":
      return addonStaff;
    case "addonChatWidget":
      return addonChatWidget;
    default:
      return null;
  }
});
</script>

<template>
  <div class="border border-[#EAECF0] rounded-lg">
    <div
      class="rounded-t-lg overflow-hidden"
      v-html="icon"
      v-if="addon.svg"
    ></div>
    <div class="p-5">
      <div
        class="text-[#101828] font-semibold text-[20px] flex justify-between capitalize"
        v-if="addon.name"
      >
        {{ addon.name }}
        <Toggle v-model="addon.status" @change="toggleClicked()"></Toggle>
      </div>
      <div class="text-[#475467] text-sm mt-[15px]">{{ addon.details }}</div>
    </div>
  </div>
</template>
